// Dev-only logger.
// Production builds: every call is a no-op.
// Development: emits via console.
// Wrap real error tracking (Sentry, Honeybadger, etc.) here when ready.

const IS_DEV = (() => {
  try {
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV) {
      return process.env.NODE_ENV !== "production";
    }
  } catch (envErr) {
    // process is undefined in some embedded targets, default to dev (safer than going silent)
    if (typeof console !== "undefined" && console.warn) {
      // eslint-disable-next-line no-console
      console.warn("logger: could not read NODE_ENV; defaulting to dev mode", envErr);
    }
    return true;
  }
  return true;
})();

function safe(method, args) {
  if (!IS_DEV) return;
  try {
    if (typeof console !== "undefined" && typeof console[method] === "function") {
      // eslint-disable-next-line no-console
      console[method].apply(console, args);
      return;
    }
  } catch (loggerErr) {
    // Final fallback: if even the standard console method throws, try plain console.error.
    // We never silently swallow, if THAT also throws, the runtime has bigger problems than logging.
    try {
      if (typeof console !== "undefined" && typeof console.error === "function") {
        // eslint-disable-next-line no-console
        console.error("logger: primary console call failed", loggerErr);
      }
    } catch (_) {
      // No console at all, nothing more we can do.
      void loggerErr;
    }
  }
}

const logger = {
  info: (...args) => safe("info", args),
  warn: (...args) => safe("warn", args),
  error: (...args) => safe("error", args),
  debug: (...args) => safe("debug", args),
};

export default logger;
export { logger };
